/**
 * @name broccoli
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTNhMyAzIDAgMCAxLTIuMTIxLTUuMTIxIiAvPgogIDxwYXRoIGQ9Ik0xNS42MDYgMTQuMjA0Yy0zLjUgMS41LTUuODk5IDQuNTAzLTguODk5IDcuNTAzQTEgMSAwIDAgMSA2IDIyYy0yIDAtNC0yLTQtNGExIDEgMCAwIDEgLjI5My0uNzA3YzEuOTExLTEuOTExIDMuODIzLTMuNTc4IDUuMzQ3LTUuNDQxIiAvPgogIDxwYXRoIGQ9Ik0xNi41NzMgMTQuNzM3QTQgNCAwIDAgMSAxNCAxMSIgLz4KICA8cGF0aCBkPSJNNy4xNCAxMC45MDdhNCA0IDAgMSAxIDIuNzU2LTcuNDNBNCA0IDAgMCAxIDE2LjcgNC40OGEyIDIgMCAwIDEgMi44MiAyLjgyIDQgNCAwIDAgMSAxLjAwMiA2LjgwNUE0IDQgMCAxIDEgMTMgMTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/broccoli
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Broccoli: string = `
<svg
  class="lucide lucide-broccoli"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 13a3 3 0 0 1-2.121-5.121" />
  <path d="M15.606 14.204c-3.5 1.5-5.899 4.503-8.899 7.503A1 1 0 0 1 6 22c-2 0-4-2-4-4a1 1 0 0 1 .293-.707c1.911-1.911 3.823-3.578 5.347-5.441" />
  <path d="M16.573 14.737A4 4 0 0 1 14 11" />
  <path d="M7.14 10.907a4 4 0 1 1 2.756-7.43A4 4 0 0 1 16.7 4.48a2 2 0 0 1 2.82 2.82 4 4 0 0 1 1.002 6.805A4 4 0 1 1 13 16" />
</svg>
`;

export default Broccoli;
